export default __webpack_public_path__ + "static/media/roboto-v20-latin-900.bac8362e.woff";